/* ===========================================================================
   VJ-CORR-D367 — LA VISIONNEUSE DE PHOTOS DE LA FICHE, À LA FASHIONICA
   14 septembre 2026, soir (dix-huitième tour)
   ---------------------------------------------------------------------------
   Rachid : « elle a rajouté une option : lorsque tu cliques sur la photo, tu
   accèdes à une autre page avec le titre du produit, une façon de l'afficher,
   et en bas plein de petits cercles pour te montrer toutes les photos
   suivantes — hyper smart, je veux bien qu'on reproduise ce modèle. »

   Relevé chez fashionica (1 440 × 695, tmp-r18-fashionica-lb.js) : sol crème
   plein écran ; titre en haut à gauche précédé d'un chevron de retour ; photo
   centrée, 44 px sous le haut ; flèches carrées de 50 px à mi-hauteur, à 40 px
   des bords ; croix carrée en haut à droite ; rangée de cercles de 80 px
   (écart 20) en bas, le cercle courant cerclé. Sur téléphone : photo pleine
   largeur, titre dans un cartouche crème posé sur la photo, cercles en bas
   qu'on fait glisser.

   On ne réécrit pas une visionneuse : le thème embarque PhotoSwipe 5.3.2, qui
   sait déjà glisser au doigt, pincer pour zoomer, piéger le focus, fermer à
   Échap et rendre le focus au clic d'origine. On lui donne NOTRE interface :
   options de PhotoSwipe (fond crème opaque, pas de compteur, flèches et croix
   dessinées ici) et deux éléments enregistrés — le titre et les cercles.
   L'initialisation par défaut vivait en ligne dans sections/main-product.liquid ;
   elle est remplacée par ce fichier (une seule visionneuse par galerie).

   La photo est ajustée dans l'espace laissé libre (`initialZoomLevel: fit`) :
   une photo 9:16 n'est JAMAIS rognée. Les marges réservent la place du titre,
   des flèches et des cercles : `margesPour`.

   Rollback : remettre le script en ligne de main-product.liquid (voir le git
   de D367) et supprimer ce fichier et le bloc D367 de vj-premium.css.
   =========================================================================== */
(function () {
  'use strict';

  var TELEPHONE = 767.98;

  var CHEVRON_G = '<svg class="vj-vis__icn" viewBox="0 0 24 24" width="22" height="22" aria-hidden="true" focusable="false"><path d="M14.5 5.5 8 12l6.5 6.5" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  var CHEVRON_D = '<svg class="vj-vis__icn" viewBox="0 0 24 24" width="22" height="22" aria-hidden="true" focusable="false"><path d="M9.5 5.5 16 12l-6.5 6.5" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  var CROIX = '<svg class="vj-vis__icn" viewBox="0 0 24 24" width="20" height="20" aria-hidden="true" focusable="false"><path d="M6.5 6.5l11 11M17.5 6.5l-11 11" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round"/></svg>';

  /* Les marges de la photo, relevées chez fashionica puis ramenées à nos
     boutons. Ordinateur : 44 en haut (le titre vit à côté de la photo, pas
     au-dessus), 138 en bas (cercles 80 + 30 d'air + 28 sous eux), 120 de
     chaque côté pour les flèches. Téléphone : la photo prend toute la largeur,
     et le bas garde la rangée de cercles (56 + 14 + 14). */
  function margesPour(taille) {
    if (taille.x <= TELEPHONE) {
      return { top: 0, bottom: 84, left: 0, right: 0 };
    }
    return { top: 44, bottom: 138, left: 120, right: 120 };
  }

  /* Une vignette légère pour les cercles : la même image au CDN, en 240 px. */
  function vignette(a) {
    var img = a.querySelector('img');
    var src = img ? (img.currentSrc || img.getAttribute('src') || '') : (a.getAttribute('href') || '');
    if (!src) return '';
    if (/[?&]width=\d+/.test(src)) return src.replace(/([?&])width=\d+/, '$1width=240');
    return src + (src.indexOf('?') === -1 ? '?' : '&') + 'width=240';
  }

  function monter(liste) {
    if (liste.dataset.vjVisionneuse === '1') return;
    if (typeof window.PhotoSwipeLightbox !== 'function' || typeof window.PhotoSwipe !== 'function') return;
    liste.dataset.vjVisionneuse = '1';

    var hote = liste.closest('wdt-main-media') || liste.closest('[data-main-gallery-id]') || document;
    var titreFiche = (hote.getAttribute && hote.getAttribute('data-vj-titre')) ||
      ((document.querySelector('.product__title') || {}).textContent || '').trim();
    var galerie = liste.closest('.product-media-gallery');

    var lightbox = new window.PhotoSwipeLightbox({
      gallery: liste,
      children: 'a[data-pswp-width]',
      pswpModule: window.PhotoSwipe,
      mainClass: 'vj-visionneuse',
      bgOpacity: 1,
      showHideAnimationType: 'fade',
      paddingFn: margesPour,
      counter: false,
      zoom: false,
      arrowPrevSVG: CHEVRON_G,
      arrowNextSVG: CHEVRON_D,
      closeSVG: CROIX,
      arrowPrevTitle: 'Photo précédente',
      arrowNextTitle: 'Photo suivante',
      closeTitle: 'Fermer',
      /* un clic sur la photo l'agrandit (on examine une pièce d'occasion) ;
         un toucher ne cache pas l'interface, le double toucher zoome */
      imageClickAction: 'zoom',
      tapAction: false,
      doubleTapAction: 'zoom',
      bgClickAction: 'close',
      errorMsg: 'La photo ne peut pas être chargée.'
    });

    lightbox.on('uiRegister', function () {
      var pswp = lightbox.pswp;

      /* 1 · LE TITRE, précédé du chevron de retour (fashionica : « < Titre ») */
      pswp.ui.registerElement({
        name: 'vj-titre',
        className: 'vj-vis__entete',
        appendTo: 'root',
        order: 5,
        onInit: function (el) {
          var retour = document.createElement('button');
          retour.type = 'button';
          retour.className = 'vj-vis__retour';
          retour.setAttribute('aria-label', 'Revenir à la fiche');
          retour.innerHTML = CHEVRON_G;
          retour.addEventListener('click', function () { pswp.close(); });
          var h = document.createElement('h2');
          h.className = 'vj-vis__titre';
          h.textContent = titreFiche;
          el.appendChild(retour);
          el.appendChild(h);
        }
      });

      /* 2 · LES CERCLES : une pastille-photo par vue, la courante cerclée */
      pswp.ui.registerElement({
        name: 'vj-cercles',
        className: 'vj-vis__cercles',
        appendTo: 'root',
        order: 9,
        onInit: function (el) {
          var n = pswp.getNumItems();
          if (n < 2) { el.hidden = true; return; }
          el.setAttribute('role', 'group');
          el.setAttribute('aria-label', 'Toutes les photos');
          var piste = document.createElement('div');
          piste.className = 'vj-vis__piste';
          el.appendChild(piste);
          var boutons = [];
          for (var i = 0; i < n; i++) {
            var data = pswp.getItemData(i);
            var b = document.createElement('button');
            b.type = 'button';
            b.className = 'vj-vis__cercle';
            b.setAttribute('aria-label', 'Photo ' + (i + 1) + ' sur ' + n);
            var src = data && data.element ? vignette(data.element) : '';
            if (src) {
              var im = document.createElement('img');
              im.src = src;
              im.alt = '';
              im.loading = 'lazy';
              im.draggable = false;
              b.appendChild(im);
            }
            (function (index) {
              b.addEventListener('click', function () { pswp.goTo(index); });
            })(i);
            piste.appendChild(b);
            boutons.push(b);
          }
          function suivre() {
            var k = pswp.currIndex;
            for (var j = 0; j < boutons.length; j++) {
              var elle = j === k;
              boutons[j].classList.toggle('est-courant', elle);
              boutons[j].setAttribute('aria-current', elle ? 'true' : 'false');
            }
            var c = boutons[k];
            if (!c) return;
            var bc = c.getBoundingClientRect();
            var bp = piste.getBoundingClientRect();
            if (bc.left < bp.left + 8 || bc.right > bp.right - 8) {
              piste.scrollTo({ left: piste.scrollLeft + (bc.left - bp.left) - (bp.width - bc.width) / 2, behavior: 'smooth' });
            }
          }
          pswp.on('change', suivre);
          suivre();
        }
      });
    });

    /* En quittant la visionneuse, la galerie du téléphone se pose sur la
       dernière photo regardée. */
    lightbox.on('close', function () {
      var pswp = lightbox.pswp;
      var sw = galerie && galerie.swiper;
      if (!pswp || !sw || !sw.enabled || typeof sw.slideTo !== 'function') return;
      if (sw.activeIndex !== pswp.currIndex) sw.slideTo(pswp.currIndex, 0);
    });

    lightbox.init();
  }

  function demarrer(essais) {
    var listes = document.querySelectorAll('.mainProduct .product-media-gallery .product__media-list');
    if (!listes.length) return;
    if (typeof window.PhotoSwipeLightbox !== 'function' || typeof window.PhotoSwipe !== 'function') {
      if (essais > 0) window.setTimeout(function () { demarrer(essais - 1); }, 250);
      return;
    }
    for (var i = 0; i < listes.length; i++) monter(listes[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { demarrer(20); });
  } else {
    demarrer(20);
  }
  document.addEventListener('shopify:section:load', function () { demarrer(20); });
})();
